// Centralized mock/static data used across features for consistent mockups
// Combines employees, attendance, devices, and sites mock datasets

// --- Attendance filter/options ---
export const filterData = [
  {
    building: "ANNEX Building",
    devices: [
      { floor: "A201-A206", biometrics: 2 },
      { floor: "A301-A308", biometrics: 2 },
      { floor: "A401-A408", biometrics: 2 },
      { floor: "EduTech", biometrics: 1 },
    ],
  },
  {
    building: "Main Building",
    devices: [
      { floor: "GF PE Area & Quad", biometrics: 2 },
      { floor: "M201-M207", biometrics: 2 },
      { floor: "M208-M214", biometrics: 2 },
      { floor: "M309-M314", biometrics: 2 },
      { floor: "M401-M407", biometrics: 2 },
      { floor: "M408-M411", biometrics: 2 },
    ],
  },
  {
    building: "New Building",
    devices: [
      { floor: "N101-N105", biometrics: 2 },
      { floor: "N201-N204", biometrics: 2 },
      { floor: "N301-N306", biometrics: 2 },
      { floor: "N401-N406", biometrics: 2 },
    ],
  },
];

// attendanceRecords and RECENT_LOGS are derived below from employeeAttendanceHistory to keep a single source of truth


// --- Recent activity per employee (human-friendly activity feed)
// Each entry: { id, type, description, timestamp }
// timestamp is ISO to make relative formatting simple when rendered
// helper: returns 'Time-in today' or 'Time-out 2 days ago' given iso timestamp and action
function activityLabelFromTs(isoTs, action) {
  const ts = new Date(isoTs).getTime();
  const diffDays = Math.floor((Date.now() - ts) / (24 * 60 * 60 * 1000));
  if (diffDays === 0) return `${action} today`;
  return `${action} ${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
}
export const employeeRecentActivity = (() => {
  // build timestamps
  const now = new Date();
  const tsNow = now.toISOString();
  const ts5min = new Date(Date.now() - 5 * 60 * 1000).toISOString();
  const ts1min = new Date(Date.now() - 60 * 1000).toISOString();
  const ts1day = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
  const ts2day = new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString();
  const ts3day = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString();

  return {
    EMP001: [
      { id: 'ACT-EMP001-1', type: 'Time-in', description: activityLabelFromTs(tsNow, 'Time-in'), timestamp: tsNow },
      { id: 'ACT-EMP001-2', type: 'Time-out', description: activityLabelFromTs(ts2day, 'Time-out'), timestamp: ts2day },
    ],
    EMP002: [
      { id: 'ACT-EMP002-1', type: 'Time-out', description: activityLabelFromTs(ts2day, 'Time-out'), timestamp: tsNow },
      { id: 'ACT-EMP002-2', type: 'Time-in', description: activityLabelFromTs(ts2day, 'Time-in'), timestamp: ts2day },
    ],
    EMP003: [
      { id: 'ACT-EMP003-1', type: 'Time-in', description: activityLabelFromTs(tsNow, 'Time-in'), timestamp: tsNow },
      { id: 'ACT-EMP003-2', type: 'Time-out', description: activityLabelFromTs(ts2day, 'Time-out'), timestamp: ts2day },
    ],
    EMP004: [
      { id: 'ACT-EMP004-1', type: 'Time-in', description: activityLabelFromTs(tsNow, 'Time-in'), timestamp: tsNow },
      { id: 'ACT-EMP004-2', type: 'Time-out', description: activityLabelFromTs(ts2day, 'Time-out'), timestamp: ts2day },
    ],
    EMP005: [],
    EMP006: [],
  };
})();

// --- Employees ---
export const employeeRecords = [
  {
    id: "EMP001",
    name: "Juan Dela Cruz",
    employeeId: "EMP001",
    department: "IT",
    position: "Faculty",
    employmentType: "Full-Time",
    phone: "+63 912 345 6789",
    email: "juan.delacruz@example.com",
    manager: "Luz Santos",
    dateStarted: "2020-08-15",
    workSchedule: "Sat: 08:00 AM - 05:00 PM" ,
    status: "Active",
    building: "ANNEX Building",
    area: "A201-A206",
    socials: { facebook: "https://facebook.com/juan", instagram: "https://instagram.com/juan", linkedin: "https://linkedin.com/in/juan" },
  },
  {
    id: "EMP002",
    name: "John Smith",
    employeeId: "EMP002",
    department: "IT",
    position: "Faculty",
    employmentType: "Full-Time",
    phone: "+63 912 345 6789",
    email: "john.smith@example.com",
    manager: "Luz Santos",
    dateStarted: "2020-08-15",
    workSchedule: "Sat: 08:00 AM - 05:00 PM",
    status: "Active",
    building: "Main Building",
    area: "A201-A206",
    socials: { facebook: "https://facebook.com/john", instagram: "https://instagram.com/john", linkedin: "https://linkedin.com/in/john" },
  },
  {
    id: "EMP003",
    name: "Maria Santos",
    employeeId: "EMP003",
    department: "Math",
    position: "Faculty",
    employmentType: "Part-Time",
    phone: "+63 923 555 1212",
    email: "maria.santos@example.com",
    manager: "Luz Santos",
    dateStarted: "2022-01-10",
    workSchedule: "Mon: 09:00 AM - 03:00 PM",
    status: "Active",
    building: "ANNEX Building",
    area: "A301-A308",
    socials: { facebook: "https://facebook.com/maria", instagram: "https://instagram.com/maria", linkedin: "https://linkedin.com/in/maria" },
  },
  {
    id: "EMP004",
    name: "Pedro Reyes",
    employeeId: "EMP004",
    department: "Science",
    position: "Lab Assistant",
    employmentType: "Full-Time",
    phone: "+63 917 111 2222",
    email: "pedro.reyes@example.com",
    manager: "Marco Dela Cruz",
    dateStarted: "2019-03-25",
    workSchedule: "Mon: 08:00 AM - 05:00 PM",
    status: "Inactive",
    building: "Main Building",
    area: "M201-M207",
    socials: { facebook: "https://facebook.com/pedro", instagram: "", linkedin: "" },
  },
  {
    id: "EMP005",
    name: "Ana Cruz",
    employeeId: "EMP005",
    department: "English",
    position: "Faculty",
    employmentType: "Full-Time",
    phone: "+63 918 222 3333",
    email: "ana.cruz@example.com",
    manager: "Marisol Reyes",
    dateStarted: "2021-09-01",
    workSchedule: "Tue: 08:30 AM - 05:30 PM",
    status: "Active",
    building: "New Building",
    area: "N301-N306",
    socials: { facebook: "https://facebook.com/ana", instagram: "https://instagram.com/ana", linkedin: "https://linkedin.com/in/ana" },
  },
  {
    id: "EMP006",
    name: "Josefa Luna",
    employeeId: "EMP006",
    department: "English",
    position: "Faculty",
    employmentType: "Full-Time",
    phone: "+63 918 222 3333",
    email: "josefa.luna@example.com",
    manager: "Marisol Reyes",
    dateStarted: "2021-09-01",
    workSchedule: "Wed: 08:30 AM - 05:30 PM",
    status: "Active",
    building: "New Building",
    area: "N301-N306",
    socials: { facebook: "https://facebook.com/ana", instagram: "https://instagram.com/ana", linkedin: "https://linkedin.com/in/ana" },
  }
];

// Ensure each employee record has a `recetAcivity` field matching the most recent activity description
// This runs after `employeeRecords` and `employeeRecentActivity` are defined.
try {
  if (typeof employeeRecentActivity === 'object' && employeeRecentActivity !== null) {
    employeeRecords.forEach((emp) => {
      const acts = employeeRecentActivity[emp.id];
      if (Array.isArray(acts) && acts.length) {
        // use the first (most recent) activity's description
        // leave existing value if already present but prefer feed's latest
        emp.recetAcivity = acts[0].description || (emp.recetAcivity || '');
      } else {
        emp.recetAcivity = emp.recetAcivity || '';
      }
    });
  }
} catch (e) {
  // don't throw during module load; just warn
  // eslint-disable-next-line no-console
  console.warn('Could not sync recetAcivity fields:', e && e.message ? e.message : e);
}

export const employeeAttendanceHistory = {
  EMP001: [
    // Recent demo days including today and next 3 days for DatePicker mockups
    { date: "Sept 23, 2025", status: "Present", timeIn: "07:55 AM", timeOut: "04:15 PM", remarks: "On time", overtimeHours: 0.25 },
    { date: "Sept 24, 2025", status: "Late", timeIn: "08:20 AM", timeOut: "05:00 PM", remarks: "Traffic", overtimeHours: 0 },
    { date: "Sept 25, 2025", status: "Present", timeIn: "08:00 AM", timeOut: "05:00 PM", remarks: "On time", overtimeHours: 0.5 },
    { date: "Sept 26, 2025", status: "Absent", timeIn: "--", timeOut: "--", remarks: "Personal leave", overtimeHours: 0 },
    // earlier sample data
    { date: "Sept 27, 2025", status: "Present", timeIn: "08:00 AM", timeOut: "05:00 PM", remarks: "On time", overtimeHours: 0.5 },
    { date: "Sept 29, 2025", status: "Late", timeIn: "08:15 AM", timeOut: "05:00 PM", remarks: "Traffic", overtimeHours: 0 },
    { date: "Sept 30, 2025", status: "Absent", timeIn: "--", timeOut: "--", remarks: "Sick leave", overtimeHours: 0 },
  ],
  EMP002: [
    { date: "Sept 23, 2025", status: "Present", timeIn: "09:00 AM", timeOut: "03:00 PM", remarks: "Part-time schedule", overtimeHours: 0 },
    { date: "Sept 24, 2025", status: "Present", timeIn: "09:00 AM", timeOut: "03:00 PM", remarks: "Part-time schedule", overtimeHours: 0 },
    { date: "Sept 25, 2025", status: "Absent", timeIn: "--", timeOut: "--", remarks: "Personal leave", overtimeHours: 0 },
  ],
  EMP003: [
    { date: "Sept 23, 2025", status: "Present", timeIn: "09:00 AM", timeOut: "03:00 PM", remarks: "Part-time schedule", overtimeHours: 0 },
    { date: "Sept 24, 2025", status: "Present", timeIn: "09:00 AM", timeOut: "03:00 PM", remarks: "Part-time schedule", overtimeHours: 0 },
    { date: "Sept 25, 2025", status: "Absent", timeIn: "--", timeOut: "--", remarks: "Personal leave", overtimeHours: 0 },
  ],
  EMP004: [
    { date: "Sept 25, 2025", status: "Inactive", timeIn: "--", timeOut: "--", remarks: "No attendance", overtimeHours: 0 },
  ],
  EMP005: [
    { date: "Sept 23, 2025", status: "Present", timeIn: "08:30 AM", timeOut: "05:30 PM", remarks: "On time", overtimeHours: 0.75 },
    { date: "Sept 24, 2025", status: "Present", timeIn: "08:30 AM", timeOut: "05:30 PM", remarks: "On time", overtimeHours: 0.5 },
    { date: "Sept 25, 2025", status: "Late", timeIn: "08:45 AM", timeOut: "05:30 PM", remarks: "Traffic delay", overtimeHours: 0 },
  ],
  EMP006: [
    { date: "Sept 22, 2025", status: "Present", timeIn: "08:30 AM", timeOut: "05:30 PM", remarks: "On time", overtimeHours: 0.75 },
    { date: "Sept 23, 2025", status: "Present", timeIn: "08:30 AM", timeOut: "05:30 PM", remarks: "On time", overtimeHours: 0.5 },
    { date: "Sept 24, 2025", status: "Late", timeIn: "08:45 AM", timeOut: "05:30 PM", remarks: "Traffic delay", overtimeHours: 0 },
  ]
};

export const employeeLogs = {
  EMP001: [
    // Logs matching the demo attendance dates (today + next 3 days)
    { logId: "LOG101", type: "Time-in", method: "Biometric", timestamp: "Sept 23, 2025 7:55 AM" },
    { logId: "LOG102", type: "Time-Out", method: "Biometric", timestamp: "Sept 23, 2025 4:15 PM" },
    { logId: "LOG103", type: "Time-in", method: "Biometric", timestamp: "Sept 24, 2025 8:20 AM" },
    { logId: "LOG104", type: "Time-Out", method: "Biometric", timestamp: "Sept 24, 2025 5:00 PM" },
    { logId: "LOG105", type: "Time-in", method: "Biometric", timestamp: "Sept 25, 2025 8:00 AM" },
    { logId: "LOG106", type: "Time-Out", method: "Biometric", timestamp: "Sept 25, 2025 5:00 PM" },
    { logId: "LOG107", type: "Time-in", method: "Biometric", timestamp: "Sept 26, 2025 00:00 AM" },
    // earlier sample logs
    { logId: "LOG001", type: "Time-in", method: "Biometric", timestamp: "Sept 25, 2025 8:00 AM" },
    { logId: "LOG002", type: "Time-Out", method: "Biometric", timestamp: "Sept 25, 2025 5:00 PM" },
  ],
  EMP002: [
    { logId: "LOG003", type: "Time-in", method: "PIN", timestamp: "Sept 24, 2025 9:00 AM" },
    { logId: "LOG004", type: "Time-Out", method: "PIN", timestamp: "Sept 24, 2025 3:00 PM" },
  ],
  EMP003: [
    { logId: "LOG003", type: "Time-in", method: "PIN", timestamp: "Sept 24, 2025 9:00 AM" },
    { logId: "LOG004", type: "Time-Out", method: "PIN", timestamp: "Sept 24, 2025 3:00 PM" },
  ],
  EMP004: [
    { logId: "LOG005", type: "Time-in", method: "Biometric", timestamp: "Sept 23, 2025 8:30 AM" },
    { logId: "LOG006", type: "Time-Out", method: "Biometric", timestamp: "Sept 23, 2025 5:30 PM" },
  ],
  EMP005: [
    { logId: "LOG005", type: "Time-in", method: "Biometric", timestamp: "Sept 23, 2025 8:30 AM" },
    { logId: "LOG006", type: "Time-Out", method: "Biometric", timestamp: "Sept 23, 2025 5:30 PM" },
  ],
  EMP006: [
    { logId: "LOG005", type: "Time-in", method: "Biometric", timestamp: "Sept 24, 2025 5:00 PM" },
    { logId: "LOG006", type: "Time-Out", method: "Biometric", timestamp: "Sept 24, 2025 5:30 PM" },
  ],
};

// --- Derived unified attendanceRecords and RECENT_LOGS ---
// Build a quick lookup for employees by id
const EMP_BY_ID = Object.fromEntries(employeeRecords.map(e => [e.id, e]));

// Flatten attendance history with employee info into attendanceRecords
export const attendanceRecords = Object.entries(employeeAttendanceHistory).flatMap(([empId, entries]) => {
  const emp = EMP_BY_ID[empId] || null;
  if (!emp || !Array.isArray(entries)) return [];
  return entries.map((rec, idx) => ({
    // preserve keys expected by Attendance table
    id: emp.id, // Employee ID used for navigation and display
    name: emp.name,
    department: emp.department,
    position: emp.position,
    date: rec.date, // mock-formatted date like "Sept 23, 2025"
    timeIn: rec.timeIn ?? "--",
    timeOut: rec.timeOut ?? "--",
    status: rec.status,
    remarks: rec.remarks ?? "",
  }));
});

// Build RECENT_LOGS by flattening employeeLogs with employee names
const METHODS = ["Fingerprint", "Card", "PIN"];
export const RECENT_LOGS = Object.entries(employeeLogs).flatMap(([empId, logs]) => {
  const emp = EMP_BY_ID[empId] || null;
  if (!emp || !Array.isArray(logs)) return [];
  return logs.map((l, idx) => ({
    id: l.logId || `${empId}-${idx}`,
    name: emp.name,
    type: l.type || "Attendance",
    method: l.method || METHODS[idx % METHODS.length],
    timestamp: l.timestamp,
  }));
});


// --- Devices (copied from devices.constants) ---
function generateId(seed) {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  const base = hash.toString(36).toUpperCase();
  const padded = (base + 'ABCDEFGH').slice(0, 7);
  return `ID:${padded}`;
}

function dateInRange(index) {
  const start = new Date('2025-08-26T00:00:00Z');
  const days = 15;
  const d = new Date(start);
  d.setUTCDate(start.getUTCDate() + (index % days));
  return d.toISOString();
}

const SITE_AREAS = [
  { site: 'ANNEX Building', area: 'A201-A206', count: 2 },
  { site: 'ANNEX Building', area: 'A301-A308', count: 2 },
  { site: 'ANNEX Building', area: 'A401-A408', count: 2 },
  { site: 'ANNEX Building', area: 'EduTech', count: 1 },
  { site: 'Main Building', area: 'GF PE Area & Quad', count: 2 },
  { site: 'Main Building', area: 'M201-M207', count: 2 },
  { site: 'Main Building', area: 'M208-M214', count: 2 },
  { site: 'Main Building', area: 'M309-M314', count: 2 },
  { site: 'Main Building', area: 'M401-M407', count: 2 },
  { site: 'Main Building', area: 'M408-M411', count: 2 },
  { site: 'New Building', area: 'N101-N105', count: 2 },
  { site: 'New Building', area: 'N201-N204', count: 2 },
  { site: 'New Building', area: 'N301-N306', count: 2 },
  { site: 'New Building', area: 'N401-N406', count: 2 },
];

export const DEVICES = (() => {
  const items = [];
  let idx = 0;
  for (const { site, area, count } of SITE_AREAS) {
    for (let i = 1; i <= count; i += 1) {
      const name = `Biometric ${area} #${i}`;
      const id = generateId(`${site}|${area}|${i}`);
      const dateAdded = dateInRange(idx);
      const status = idx % 5 === 0 ? 'Offline' : 'Online';
      const type = i % 2 === 0 ? 'Check Out' : 'Check In';

      items.push({ id, name, site, area, status, dateAdded, lastActivity: dateAdded, type });
      idx += 1;
    }
  }
  return items;
})();

export const SORT_OPTIONS = [
  { key: 'az', label: 'Alphabetical (A–Z)' },
  { key: 'za', label: 'Alphabetical (Z–A)' },
  { key: 'newest', label: 'Newest' },
  { key: 'oldest', label: 'Oldest' },
];

// --- Sites aggregation ---
function generateLogs(device) {
  if (!device) return [];
  const people = [
    { id: '100231', name: 'Juan Dela Cruz' },
    { id: '100412', name: 'Maria Santos' },
    { id: '100557', name: 'Lito Reyes' },
    { id: '100901', name: 'Ana Cruz' },
  ];
  const methods = ['Fingerprint', 'Card', 'PIN'];
  const events = ['Attendance'];
  const out = [];
  for (let i = 0; i < 12; i += 1) {
    const p = people[i % people.length];
    const method = methods[i % methods.length];
    const event = events[i % events.length];
    const result = i % 7 === 0 ? 'Denied' : 'Success';
    const time = new Date(new Date(device.dateAdded).getTime() + i * 3600 * 1000)
      .toISOString()
      .replace('T', ' ')
      .slice(0, 19);
    out.push({ name: p.name, userId: p.id, time, event, verifyMethod: method, result });
  }
  return out;
}

function countLast24h(logs) {
  const cutoff = Date.now() - 24 * 60 * 60 * 1000;
  return logs.filter(l => new Date(l.time).getTime() >= cutoff).length;
}

function aggregateSites(devices) {
  const map = new Map();
  for (const d of devices) {
    if (!map.has(d.site)) {
      map.set(d.site, {
        name: d.site,
        devices: 0,
        areas: new Set(),
        latest: d.dateAdded,
        todaysLogs: 0,
      });
    }
    const s = map.get(d.site);
    s.devices += 1;
    s.areas.add(d.area);
    if (new Date(d.dateAdded) > new Date(s.latest)) s.latest = d.dateAdded;
    s.todaysLogs += countLast24h(generateLogs(d));
  }
  return Array.from(map.values()).map(s => ({
    name: s.name,
    devices: s.devices,
    areas: Array.from(s.areas).sort(),
    latest: s.latest,
    todaysLogs: s.todaysLogs,
  }));
}

export const SITES = aggregateSites(DEVICES);

export const SITE_SORT_OPTIONS = [
  { key: 'az', label: 'Alphabetical (A–Z)' },
  { key: 'za', label: 'Alphabetical (Z–A)' },
  { key: 'devices', label: 'Devices (Most)' },
  { key: 'latest', label: 'Recently Added' },
];

// --- Centralized Position Options (used across pages) ---
// Deduplicate positions from both employee and attendance datasets for consistency
export const POSITIONS = Array.from(new Set([
  ...employeeRecords.map(e => e.position).filter(Boolean),
  ...attendanceRecords.map(r => r.position).filter(Boolean),
])).sort();

// Object-style options commonly used by Attendance filters
export const POSITION_OPTIONS = POSITIONS.map(p => ({ key: p, label: p }));

// String+object mixed list commonly used by FilterPanel in Employees page
export const POSITION_FILTER_VALUES = [
  "All Position",
  ...POSITIONS.map(p => ({ key: p, label: p }))
];

// --- Centralized Department Options ---
export const DEPARTMENTS = Array.from(new Set([
  ...employeeRecords.map(e => e.department).filter(Boolean),
  ...attendanceRecords.map(r => r.department).filter(Boolean),
])).sort();
export const DEPARTMENT_OPTIONS = DEPARTMENTS.map(d => ({ key: d, label: d }));
export const DEPARTMENT_FILTER_VALUES = [
  "All Department",
  ...DEPARTMENTS.map(d => ({ key: d, label: d }))
];

// --- Centralized Dashboard demo data builder ---
export function buildDemoData(selectedDate = new Date()) {
  const seedKey = selectedDate.toDateString();
  const seedFn = seededRandom(seedKey);

  // Get current date info for auto-selection
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0-11
  const currentWeek = getWeekOfMonth(now);

  // --- Utility functions ---
  function seededRandom(seed) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) {
      h = Math.imul(31, h) + seed.charCodeAt(i) | 0;
    }
    return function () {
      h = Math.imul(48271, h) % 2147483647;
      return (h & 2147483647) / 2147483648;
    };
  }

  function rand(base, seedFn) {
    if (!seedFn) {
      return Math.max(0, Math.round(base + (Math.random() - 0.5) * base * 0.2));
    }
    return Math.max(0, Math.round(base + (seedFn() - 0.5) * base * 0.2));
  }

  function getWeekOfMonth(date) {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfWeek = firstDay.getDay();
    return Math.ceil((date.getDate() + firstDayOfWeek) / 7);
  }

  // --- DAILY DATA (PRESERVED) ---
  const daily = {
    expected: 320,
    present: rand(300, seedFn),
    late: rand(15, seedFn),
    absent: rand(25, seedFn),
    notIn: rand(10, seedFn),
    notOut: rand(15, seedFn),
    timeIn: rand(210, seedFn),
    timeOut: rand(50, seedFn),
    overTime: rand(60, seedFn),
    earlyChekOut: rand(10, seedFn),
  };

  // --- DONUT DATA (PRESERVED) ---
  const donutData = {
    "Time-in": [
      { name: "Present", value: daily.present, color: "#16a34a" },
      { name: "Late", value: daily.late, color: "#f59e0b" },
      { name: "Pending", value: daily.absent, color: "#94a3b6" },
    ],
    "Time-out": [
      { name: "Time-out", value: daily.timeOut, color: "#16a34a" },
      { name: "Pending", value: daily.notOut, color: "#f59e0b" },
    ],
  };

  // --- HOURLY DATA (PRESERVED) ---
  const hours = Array.from({ length: 6 }, (_, i) => 6 + i);
  const toLabel = (h) => `${((h + 11) % 12) + 1} ${h < 12 ? "AM" : "PM"}`;

  const hoursOut = Array.from({ length: 6 }, (_, i) => 17 + i);
  const toOutLabel = (h) => `${((h + 11) % 12) + 1} ${h < 12 ? "AM" : "PM"}`;

  const dailyHourlyCounts = hours.map((h) => {
    let base;
    if (h === 6 || h === 7) base = 20;
    else if (h === 8 || h === 9) base = 55;
    else if (h === 10) base = 35;
    else if (h === 11) base = 65;
    else base = 14;
    return { label: toLabel(h), value: base + rand(6, seedFn) };
  });

  const dailyHourlyOut = hoursOut.map((h) => {
    let base;
    if (h === 17 || h === 18) base = 65;
    else if (h === 19) base = 45;
    else if (h === 20) base = 30;
    else if (h === 21) base = 15;
    else base = 6;
    return { label: toOutLabel(h), value: base + rand(6, seedFn) };
  });

  const dailyPeak = {
    "Time-in": dailyHourlyCounts.reduce(
      (acc, cur, idx) => cur.value > acc.value ? { value: cur.value, label: cur.label, index: idx } : acc,
      { value: -1, label: "", index: -1 }
    ),
    "Time-out": dailyHourlyOut.reduce(
      (acc, cur, idx) => cur.value > acc.value ? { value: cur.value, label: cur.label, index: idx } : acc,
      { value: -1, label: "", index: -1 }
    ),
  };

  // --- STATIC WEEKLY DATA ---
  const staticWeekData = [
    { label: "Sunday", present: 180, absent: 8, late: 12, total: 200 },
    { label: "Monday", present: 280, absent: 6, late: 14, total: 300 },
    { label: "Tuesday", present: 285, absent: 8, late: 12, total: 305 },
    { label: "Wednesday", present: 290, absent: 5, late: 10, total: 305 },
    { label: "Thursday", present: 295, absent: 3, late: 7, total: 305 },
    { label: "Friday", present: 275, absent: 10, late: 15, total: 300 },
    { label: "Saturday", present: 160, absent: 5, late: 8, total: 173 },
  ];

  // --- WEEKLY DATA with industry standard format ---
  const weekly = {
    "Week 1 of September 2025": staticWeekData,
    "Week 2 of September 2025": staticWeekData.map(d => ({ ...d, present: d.present + 5, absent: d.absent - 1 })),
    "Week 3 of September 2025": staticWeekData.map(d => ({ ...d, present: d.present + 10, absent: d.absent - 2 })),
    "Week 4 of September 2025": staticWeekData.map(d => ({ ...d, present: d.present + 3, absent: d.absent + 1 })),
    "Week 1 of October 2025": staticWeekData.map(d => ({ ...d, present: d.present + 8, absent: d.absent - 1 })),
    "Week 2 of October 2025": staticWeekData.map(d => ({ ...d, present: d.present + 12, absent: d.absent - 2 })),
    "Week 3 of October 2025": staticWeekData.map(d => ({ ...d, present: d.present + 6, absent: d.absent + 1 })),
    "Week 4 of October 2025": staticWeekData.map(d => ({ ...d, present: d.present + 9, absent: d.absent - 1 })),
    "Week 1 of November 2025": staticWeekData.map(d => ({ ...d, present: d.present + 4, absent: d.absent + 2 })),
    "Week 2 of November 2025": staticWeekData.map(d => ({ ...d, present: d.present + 7, absent: d.absent - 1 })),
    "Week 3 of November 2025": staticWeekData.map(d => ({ ...d, present: d.present + 11, absent: d.absent - 3 })),
    "Week 4 of November 2025": staticWeekData.map(d => ({ ...d, present: d.present + 2, absent: d.absent + 1 })),
    "Week 1 of December 2025": staticWeekData.map(d => ({ ...d, present: d.present + 6, absent: d.absent + 1 })),
    "Week 2 of December 2025": staticWeekData.map(d => ({ ...d, present: d.present + 8, absent: d.absent - 2 })),
    "Week 3 of December 2025": staticWeekData.map(d => ({ ...d, present: d.present + 5, absent: d.absent + 2 })),
    "Week 4 of December 2025": staticWeekData.map(d => ({ ...d, present: d.present + 3, absent: d.absent + 3 })),
  };

  const weeksList = Object.keys(weekly).map(key => ({ key, label: key }));

  // --- STATIC MONTHLY DATA (Day 1 to Day 31) ---
  const generateMonthDays = (daysCount, basePresent = 280) => {
    return Array.from({ length: daysCount }, (_, i) => ({
      day: `day: ${i + 1}`,
      present: basePresent + (i % 7 === 0 || i % 7 === 6 ? -100 : 0) + rand(20),
      absent: 5 + rand(5),
      late: 8 + rand(4),
      total: (basePresent + (i % 7 === 0 || i % 7 === 6 ? -100 : 0) + rand(20)) + (5 + rand(5)) + (8 + rand(4))
    }));
  };

  const monthly = {
    "August 2025": generateMonthDays(31, 150),
    "September 2025": generateMonthDays(30, 280),
    "October 2025": generateMonthDays(31, 285),
    "November 2025": generateMonthDays(30, 275),
    "December 2025": generateMonthDays(31, 270),
    "January 2026": generateMonthDays(31, 290),
    "February 2026": generateMonthDays(28, 285),
    "March 2026": generateMonthDays(31, 295),
    "April 2026": generateMonthDays(30, 280),
    "May 2026": generateMonthDays(31, 285),
    "June 2026": generateMonthDays(30, 275),
    "July 2026": generateMonthDays(31, 280),
    "August 2026": generateMonthDays(31, 285),
  };

  const monthsList = Object.keys(monthly).map(key => ({ key, label: key }));

  // --- STATIC YEARLY DATA (Jan to Dec) ---
  const yearly = {
    "2025": [
        { month: "Jan", present: 6000, absent: 800, late: 1200, total: 8000 },
        { month: "Feb", present: 5500, absent: 1200, late: 1500, total: 8200 },
        { month: "Mar", present: 5000, absent: 1800, late: 1800, total: 8600 },
        { month: "Apr", present: 4800, absent: 2200, late: 2000, total: 9000 },
        { month: "May", present: 5200, absent: 2000, late: 2000, total: 9200 },
        { month: "Jun", present: 5400, absent: 1800, late: 1800, total: 9000 },
        { month: "Jul", present: 5600, absent: 1600, late: 1800, total: 9000 },
        { month: "Aug", present: 5800, absent: 1400, late: 1800, total: 9000 },
        { month: "Sep", present: 6000, absent: 1200, late: 1800, total: 9000 },
        { month: "Oct", present: 6200, absent: 1000, late: 1800, total: 9000 },
        { month: "Nov", present: 6400, absent: 900, late: 1700, total: 9000 },
        { month: "Dec", present: 6600, absent: 800, late: 1600, total: 9000 }
      ],
      "2026": [
        { month: "Jan", present: 6100, absent: 900, late: 1700, total: 8700 },
        { month: "Feb", present: 5700, absent: 1100, late: 1900, total: 8700 },
        { month: "Mar", present: 5300, absent: 1300, late: 2100, total: 8700 },
        { month: "Apr", present: 4900, absent: 1500, late: 2300, total: 8700 },
        { month: "May", present: 5100, absent: 1700, late: 2300, total: 9100 },
        { month: "Jun", present: 5300, absent: 1900, late: 2300, total: 9500 },
        { month: "Jul", present: 5500, absent: 2100, late: 2300, total: 9900 },
        { month: "Aug", present: 5700, absent: 2300, late: 2300, total: 10300 },
        { month: "Sep", present: 5900, absent: 2500, late: 2300, total: 10700 },
        { month: "Oct", present: 6100, absent: 2700, late: 2300, total: 11100 },
        { month: "Nov", present: 6300, absent: 2900, late: 2300, total: 11500 },
        { month: "Dec", present: 6500, absent: 3100, late: 2300, total: 11900 }
      ],
      "2027": [
        { month: "Jan", present: 6200, absent: 1000, late: 1800, total: 9000 },
        { month: "Feb", present: 5800, absent: 1200, late: 2000, total: 9000 },
        { month: "Mar", present: 5400, absent: 1400, late: 2200, total: 9000 },
        { month: "Apr", present: 5000, absent: 1600, late: 2400, total: 9000 },
        { month: "May", present: 5200, absent: 1800, late: 2400, total: 9400 },
        { month: "Jun", present: 5400, absent: 2000, late: 2400, total: 9800 },
        { month: "Jul", present: 5600, absent: 2200, late: 2400, total: 10200 },
        { month: "Aug", present: 5800, absent: 2400, late: 2400, total: 10600 },
        { month: "Sep", present: 6000, absent: 2600, late: 2400, total: 11000 },
        { month: "Oct", present: 6200, absent: 2800, late: 2400, total: 11400 },
        { month: "Nov", present: 6400, absent: 3000, late: 2400, total: 11800 },
        { month: "Dec", present: 6600, absent: 3200, late: 2400, total: 12200 }
      ]
  };

  const yearlyList = Object.keys(yearly).map(key => ({ key, label: key }));

  // --- Calculate Averages for Yearly Data ---
  const yearlyWithAverages = Object.fromEntries(
    Object.entries(yearly).map(([year, months]) => {
      const monthsWithAverages = months.map((monthData) => {
        const { present, absent, late, total } = monthData;
        const averagePresent = present / 30; // Assuming 30 days in a month
        const averageAbsent = absent / 30;
        const averageLate = late / 30;
        return {
          ...monthData,
          present: Math.round(averagePresent),
          absent: Math.round(averageAbsent),
          late: Math.round(averageLate),
        };
      });
      return [year, monthsWithAverages];
    })
  );

  // --- Calculate overall averages for each year (for dashboard summary) ---
  const yearlyAverages = Object.fromEntries(
    Object.entries(yearlyWithAverages).map(([year, months]) => {
      const totalMonths = months.length;
      const sum = months.reduce((acc, m) => {
        acc.present += m.present;
        acc.absent += m.absent;
        acc.late += m.late;
        return acc;
      }, { present: 0, absent: 0, late: 0 });
      return [year, {
        present: Math.round(sum.present / totalMonths),
        absent: Math.round(sum.absent / totalMonths),
        late: Math.round(sum.late / totalMonths),
      }];
    })
  );

  // --- AUTO-SELECTION LOGIC ---
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  
  const currentWeekKey = `Week ${currentWeek} of ${monthNames[currentMonth]} ${currentYear}`;
  const currentMonthKey = `${monthNames[currentMonth]} ${currentYear}`;
  const currentYearKey = String(currentYear);

  // Find indices for auto-selection
  const autoWeekIndex = weeksList.findIndex(w => w.key === currentWeekKey);
  const autoMonthIndex = monthsList.findIndex(m => m.key === currentMonthKey);
  const autoYearIndex = yearlyList.findIndex(y => y.key === currentYearKey);

  // console logs retained from original for traceability; remove if noisy
  // console.log(`🗓️ Auto-selecting TODAY's periods:`);
  // console.log(`   Week: ${currentWeekKey} (index: ${autoWeekIndex})`);
  // console.log(`   Month: ${currentMonthKey} (index: ${autoMonthIndex})`);
  // console.log(`   Year: ${currentYearKey} (index: ${autoYearIndex})`);

  return {
    // Preserved daily data
    daily,
    dailyHourlyCounts,
    dailyHourlyOut,
    dailyPeak,
    donutData,

    // Static data with auto-selection
    weekly,
    weeksList,
    monthly,
    monthsList,
    yearly: yearlyWithAverages,
    yearlyList,
    yearlyAverages, // { year: { present, absent, late } }

    // Auto-selection helpers
    autoSelection: {
      currentWeek: currentWeekKey,
      currentMonth: currentMonthKey,
      currentYear: currentYearKey,
      weekIndex: autoWeekIndex >= 0 ? autoWeekIndex : 0,
      monthIndex: autoMonthIndex >= 0 ? autoMonthIndex : 0,
      yearIndex: autoYearIndex >= 0 ? autoYearIndex : 0,
    }
  };
}

// --- Centralized System Logs demo builder ---
export function buildSystemLogs(count = 25) {
  const base = new Date();
  const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const rows = [];
  for (let i = 0; i < count; i++) {
    const d = new Date(base.getTime() - i * 6 * 60 * 60 * 1000);
    rows.push({
      id: `sys-${i}`,
      event: i % 5 === 0 ? 'Role Update' : i % 3 === 0 ? 'Auth Failure' : 'Login',
      actor: i % 4 === 0 ? 'system' : i % 2 === 0 ? 'admin@corp' : 'viewer@corp',
      target: i % 5 === 0 ? 'Permissions' : 'Session',
      details: i % 3 === 0 ? 'Invalid password or token' : 'OK',
      timestamp: `${toIso(d)} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}:00`,
    });
  }
  return rows;
}
